export default __webpack_public_path__ + "static/media/2019 (3).39c19cb8.JPG";